import Vue from 'vue'

const state = {
    defaultSalesChannel:{
        name: '',
        channelType: 9999, // 0=Supplier | 50=Agents | 100,101,102=Widget | 9999=custom
        isAllowedSellComponents: true,
        isAllowedSellTransports: true,
        notificationNewBooking: true,
        ticketType: 0,
        isImmutable: false,
        ticketType_helper_selected: {
            id: 0,
            label: "POS"
        }
    },
    salesChannels:null,
    selectedSalesChannel: null,
    channelsNotAllowedToHaveManualConfirmation: [
        202, // GYG
        203, // VIATOR
        204,
        210
    ]
};

const getters = {
    getSalesChannels: (state, rootstate) => {
        if(!state.salesChannels || state.salesChannels.length == 0){
            return []
        }

        // set commission helper object to user vSelect
        state.salesChannels.map(salesChannel=> {
            // sets product_helper
            salesChannel.ticketType_helper_selected = rootstate.getTicketTypes.filter(ticketSize => {
                return salesChannel.ticketType == ticketSize.id
            })[0]
        })

        return state.salesChannels
    },
    getdefaultSalesChannel: (state) => state.defaultSalesChannel,
    getSelectedSalesChannel: (state) => state.selectedSalesChannel,
    getSalesChannelsForNewProduct: (state, rootstate) => {

        if(!state.salesChannels){
            return []
        }

        let outputSalesChannels = JSON.parse(JSON.stringify(state.salesChannels))

        outputSalesChannels.map(salesChannel => {
            salesChannel.channelName = (salesChannel.channelName)? salesChannel.channelName : salesChannel.name
            salesChannel.channelId = salesChannel.id
            salesChannel.isActive = true
            salesChannel.id = null

            // Product
            salesChannel.productAmountType = 1
            salesChannel.productAmountValue = 0
            // // sets Type helper
            // salesChannel.productAmountType_helper_selected = rootstate.getPercentageOrCurrency.filter(percentageOrCurrency => {
            //     return salesChannel.productAmountType == percentageOrCurrency.id
            // })[0]

            // Component (extras)
            salesChannel.componentAmountType = 1
            salesChannel.componentAmountValue = 0
            // sets Type helper
            // salesChannel.componentAmountType_helper_selected = rootstate.getPercentageOrCurrency.filter(percentageOrCurrency => {
            //     return salesChannel.componentAmountType == percentageOrCurrency.id
            // })[0]

            // Transport
            salesChannel.transportAmountType = 1
            salesChannel.transportAmountValue = 0
            // sets Type helper
            // salesChannel.transportAmountType_helper_selected = rootstate.getPercentageOrCurrency.filter(percentageOrCurrency => {
            //     return salesChannel.transportAmountType == percentageOrCurrency.id
            // })[0]

        })

        return outputSalesChannels
    },
    getChannelsNotAllowedToHaveManualConfirmation: (state) => state.channelsNotAllowedToHaveManualConfirmation,

};

const actions = {
    downloadSalesChannels ({state, rootState, commit}){
        if(!rootState.user.account.supplierId){
            return false
        }

        return axios.get('/api/Supplier/GetChannels', {
            params: {
                supplierId: rootState.user.account.supplierId
            }
        }).then(response => {
            if(response.status == 200){

                var output = response.data.sort(function(salesChannelA, salesChannelB) {
                    if(salesChannelA.channelType == 0 || salesChannelA.channelType == 9999){
                        return -1;
                    } else{
                        return 1;
                    }
                })

                commit('SET_SALESCHANNELS', output)
            }
        })


    },
    setSelectedSalesChannel ({ state }, payload) {
        state.selectedSalesChannel = payload
    },

    createSalesChannel ({ state, rootState, commit }, payload) {
        return axios.post('/api/Supplier/CreateChannel', {
            supplierId: rootState.user.account.supplierId,
            channel: payload
        }).then(response => {
            if(response.status == 200){
                commit('ADD_SALESCHANNEL', response.data)
            }
        })
    },

    updateSalesChannel ({ state, rootState, commit }, payload) {
        return axios.post('/api/Supplier/EditChannel', {
            supplierId: rootState.user.account.supplierId,
            channel: payload
        }).then(response => {
            if(response.status == 200){
                commit('UPDATE_SALESCHANNEL', response.data)
                return true
            }
            return false
        })
    },

    deleteSalesChannel ({ state, rootState, commit }, payload) {
        return axios.post('/api/Supplier/DeleteChannel', {
            supplierId: rootState.user.account.supplierId,
            channel: payload
        }).then(response => {
            if(response.status == 200){
                if(response.data == true){
                    commit('REMOVE_SALESCHANNEL', payload)
                }
            }
        })
    },
};

const mutations = {
    SET_SALESCHANNELS: (state, payload) => {
        state.salesChannels = payload;
    },

    ADD_SALESCHANNEL: (state, payload) => {
        state.salesChannels.push(payload)
    },

    REMOVE_SALESCHANNEL: (state, payload) => {
        let index = state.salesChannels.indexOf(payload)
        state.salesChannels.splice(index, 1)
    },
	UPDATE_SALESCHANNEL: (state, payload) => {
		const index = state.salesChannels.indexOf(payload);
		const updatedSalesChannels = [...state.salesChannels]; // Create a copy of the salesChannels array
		updatedSalesChannels.splice(index, 1, payload); // Replace the salesChannel at the found index with the new payload

		// Return a new state object with the updated salesChannels array
		return {
			...state,
			salesChannels: updatedSalesChannels
		};
	}


};

export default {
    state,
    getters,
    actions,
    mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/salesChannels.js